<template>
  <div>
    <div class="_rfp_mctb_popup_01_ rfp-mctb-common-buynow-header">
      <button
        class="_rfp_mctb_popup_02_ rfp-mctb-common-buynow rfp-mctb-product-list-card-buttom"
        @click="popUpEnable(storeLocatorModeOptions.Product.BuyOnlineTags, buyNowText)"
      >
        {{ buyNowText }}
      </button>
    </div>
    <span v-if="viewType === 'Carousel'">
      <div v-if="showPopUp" class="_rfp_mctb_popup_03_ rfp-mctb-modal-mask-slider modal-vue">
        <div class="_rfp_mctb_popup_04_ rfp-mctb-modal-wrapper-slider modal-vue--content">
          <div class="_rfp_mctb_popup_05_ rfp-mctb-modal-container modal-vue--content-panel">
            <div class="_rfp_mctb_popup_06_ rfp-mctb-carousel-mode-header vue-tabs">
              <button
                class="_rfp_mctb_popup_07_ rfp-mctb-modal-close"
                :class="{ 'rfp-mctb-modal-close-rtl': enableRtl }"
                @click="popUpDisable"
              >
                X
              </button>
              <div class="_rfp_mctb_popup_08_ rfp-mctb-carousel-mode-header-top-header">
                {{ carouselHeaderText }}
              </div>

              <div
                v-if="storeLocatorModeOptions.CountryList.length != 0"
                class="_rfp_mctb_list_006_ nav-tabs-navigation"
              >
                <div class="_rfp_mctb_list_007_ nav-tabs-wrapper">
                  <ul role="tablist" class="_rfp_mctb_list_008_ nav nav-tabs">
                    <li
                      v-for="(x, index) in storeLocatorModeOptions.CountryList"
                      :id="x"
                      :key="x.DisplayName"
                      name="tab"
                      aria-selected="true"
                      :aria-controls="x"
                      role="tab"
                      class="_rfp_mctb_list_009_ tab active"
                      :class="{ active__tab: index === tabIndex }"
                      @click="tabEnable(x, index)"
                    >
                      <span role="tab" class="_rfp_mctb_list_0010_ active_tab tabs__link">
                        <span class="_rfp_mctb_list_0011_ title title_center">
                          {{ x.DisplayName }}
                        </span>
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
              <template v-if="storeLocatorModeOptions.CountryList.length != 0">
                <template v-for="(item, index) in storeLocatorModeOptions.CountryList">
                  <rfp-mctb-carousel
                    v-if="index === tabIndex && item.Name === tabValue.Name"
                    :key="item.Name"
                    :enable-rtl="enableRtl"
                    :autoplay="false"
                    :autoplay-timeout="10000"
                    :loop="false"
                    :autoplay-hover-pause="true"
                    :min-swipe-distance="8"
                    pagination-active-color="#f30606"
                    pagination-color="#efefef"
                    :pagination-padding="10"
                    :pagination-size="10"
                    :per-page="1"
                    :navigation-enabled="true"
                    :pagination-enabled="false"
                    :productname="productname"
                    :productids="productids"
                  >
                    <template v-for="x in storeLocatorModeOptions.Product.Retailers">
                      <rfp-mctb-slide
                        v-if="x.Country === item.Name && tabRetailerList.length != 0"
                        :key="x.Name"
                        :enable-rtl="enableRtl"
                      >
                        <div class="_rfp_mctb_popup_09_ rfp-mctb-slider-outer">
                          <div
                            class="_rfp_mctb_popup_10_ rfp-mctb-slider-description rfp-mctb-image-alignment"
                          >
                            <img
                              class="_rfp_mctb_popup_11_ rfp-mctb-button-image"
                              :src="x.Logo"
                              :alt="x.LogoAlt"
                            />
                          </div>
                          <p
                            class="_rfp_mctb_popup_12_ rfp-mctb-slider-description"
                            v-html="x.Description"
                          ></p>
                          <button
                            class="_rfp_mctb_popup_13_ rfp-mctb-common-buynow"
                            @click="
                              pageRedirectUrl(
                                x.RetailerUrl,
                                x.OpenInNewWindow,
                                x.RetailerTags,
                                x.RetailerTagsGS,
                                x.Name,
                              )
                            "
                          >
                            <span class="_rfp_mctb_popup_14_ rfp-mctb-button-text">
                              {{ x.Name }}
                            </span>
                          </button>
                        </div>
                      </rfp-mctb-slide>
                    </template>
                    <rfp-mctb-slide v-if="tabRetailerList.length === 0">
                      <div class="retailer-unavailable_04">
                        {{ retailerUnavailable }}
                      </div>
                    </rfp-mctb-slide>
                  </rfp-mctb-carousel>
                </template>
              </template>
              <template v-if="storeLocatorModeOptions.CountryList.length === 0">
                <rfp-mctb-carousel
                  :enable-rtl="enableRtl"
                  :autoplay="false"
                  :autoplay-timeout="10000"
                  :loop="false"
                  :autoplay-hover-pause="true"
                  :min-swipe-distance="8"
                  pagination-active-color="#f30606"
                  pagination-color="#efefef"
                  :pagination-padding="10"
                  :pagination-size="10"
                  :per-page="1"
                  :navigation-enabled="true"
                  :pagination-enabled="false"
                  :productname="productname"
                  :productids="productids"
                >
                  <rfp-mctb-slide
                    v-for="x in storeLocatorModeOptions.Product.Retailers"
                    :key="x.Name"
                    :enable-rtl="enableRtl"
                  >
                    <div class="_rfp_mctb_popup_09_ rfp-mctb-slider-outer">
                      <div
                        class="_rfp_mctb_popup_10_ rfp-mctb-slider-description rfp-mctb-image-alignment"
                      >
                        <img
                          class="_rfp_mctb_popup_11_ rfp-mctb-button-image"
                          :src="x.Logo"
                          :alt="x.LogoAlt"
                        />
                      </div>
                      <p
                        class="_rfp_mctb_popup_12_ rfp-mctb-slider-description"
                        v-html="x.Description"
                      ></p>
                      <button
                        class="_rfp_mctb_popup_13_ rfp-mctb-common-buynow"
                        @click="
                          pageRedirectUrl(
                            x.RetailerUrl,
                            x.OpenInNewWindow,
                            x.RetailerTags,
                            x.RetailerTagsGS,
                            x.Name,
                          )
                        "
                      >
                        <span class="_rfp_mctb_popup_14_ rfp-mctb-button-text">
                          {{ x.Name }}
                        </span>
                      </button>
                    </div>
                  </rfp-mctb-slide>

                  <rfp-mctb-slide v-if="storeLocatorModeOptions.Product.Retailers.length === 0">
                    <div class="retailer-unavailable_04">
                      {{ retailerUnavailable }}
                    </div>
                  </rfp-mctb-slide>
                </rfp-mctb-carousel>
              </template>
            </div>
          </div>
        </div>
      </div>
    </span>
    <span v-else-if="viewType === 'Default - PopupMode Only'">
      <div v-if="showPopUp" class="_rfp_mctb_popup_03_ rfp-mctb-modal-mask">
        <div class="_rfp_mctb_popup_04_ rfp-mctb-modal-wrapper">
          <div class="_rfp_mctb_popup_05_ rfp-mctb-modal-container">
            <div class="_rfp_mctb_popup_06_ rfp-mctb-carousel-mode-header">
              <button
                class="_rfp_mctb_popup_07_ rfp-mctb-modal-close"
                :class="{ 'rfp-mctb-modal-close-rtl': enableRtl }"
                @click="popUpDisable"
              >
                X
              </button>
              <rfp-mctb-list-mode
                :retailer-unavailable="retailerUnavailable"
                :component-diffs="componentDiffs"
                :carousel-header-text="carouselHeaderText"
                :store-locator-mode-options="storeLocatorModeOptions"
                :productname="productname"
                :productids="productids"
                :initial-extra-params="extraParams"
              ></rfp-mctb-list-mode>
            </div>
          </div>
        </div>
      </div>
    </span>
    <rfp-mctb-pop-up-action-mode
      v-else-if="showActionMode && showPopUp"
      :productname="productname"
      :productids="productids"
      :enable-buynow-retailers="enableBuynowRetailers"
      :retailer-unavailable="retailerUnavailable"
      :header-text="carouselHeaderText"
      :component-diffs="componentDiffs"
      :initial-data="storeLocatorModeOptions"
      :initial-extra-params="extraParams"
      :popup-direction="popupAlignment"
    ></rfp-mctb-pop-up-action-mode>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import RfpMctbPopUpActionMode from '../rfp-mctb-pop-up-action-mode/rfp-mctb-pop-up-action-mode.vue';
import RfpMctbListMode from '../rfp-mctb-list-mode/rfp-mctb-list-mode.vue';
import RfpMctbCarousel from '../rfp-mctb-slider/rfp-mctb-carousel.vue';
import RfpMctbSlide from '../rfp-mctb-slider/rfp-mctb-slide.vue';
import ServiceType from '../rfp-mctb-tags/tagging-service-type';

export default {
  name: 'rfp-mctb-pop-up-mode',
  components: {
    RfpMctbPopUpActionMode,
    RfpMctbListMode,
    RfpMctbCarousel,
    RfpMctbSlide,
  },
  props: {
    storeLocatorModeOptions: {
      type: Object,
      required: true,
    },
    buyNowText: {
      type: String,
      required: true,
    },
    carouselHeaderText: {
      type: String,
      default: 'Choose a Retailer',
    },
    viewType: {
      type: String,
      required: true,
    },
    enableRtl: {
      type: Boolean,
      required: true,
    },
    componentDiffs: {
      type: Boolean,
      required: true,
    },
    enableBuynowRetailers: {
      type: Boolean,
      required: true,
    },
    retailerUnavailable: {
      type: String,
      required: true,
    },
    productname: {
      type: String,
      required: true,
    },
    productids: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showPopUp: false,
      eventProjectDataLayer: {},
      tabIndex: null,
      tabValue: null,
      areaValue: true,
      tabRetailerList: [],
      extraParams: {},
      popupDirection: false,
      findDatalayer: true,
    };
  },
  computed: {
    popupAlignment() {
      let alignment = 'top';
      try {
        alignment = this.viewType.split(' - ')[0].toLowerCase();
      } catch (err) {
        return 'top';
      }

      return alignment;
    },
    showActionMode() {
      // TODO: in theory we shouldn't need this garbage, instead it would be the final ELSE in the
      // rendering
      return (
        [
          'Bottom - PopupMode Only',
          'Left - PopupMode Only',
          'Right - PopupMode Only',
          'Top - PopupMode Only',
        ].indexOf(this.viewType) >= 0
      );
    },
  },
  created() {
    if (this.storeLocatorModeOptions.CountryList.length !== 0) {
      this.tabEnable(this.storeLocatorModeOptions.CountryList[0], 0);
    }
    eventBus.on('rfp-auto-popup-open-buynow-true', () => {
      this.popupDirection = true;
      this.popUpEnable(this.storeLocatorModeOptions.Product.BuyOnlineTags, this.buyNowText);
    });
    /* istanbul ignore next */
    eventBus.on('rfp-optional-popup-close', () => {
      this.popUpDisable(true);
    });
    /* istanbul ignore next */
    eventBus.on('rfp-mctb-datalayer-event', (val) => {
      this.eventProjectDataLayer = val;
    });
    /* istanbul ignore next */
    eventBus.on('rfp-mctb-extra-param-component', (val) => {
      this.extraParams = val;
    });
    eventBus.emit('rfp-mctb-extra-param-component1');
    eventBus.on('rfp-mctb-enable-popup-direction', () => {
      this.findDatalayer = false;
      this.popupDirection = true;
      this.popUpEnable(this.storeLocatorModeOptions.Product.BuyOnlineTags, this.buyNowText);
    });
  },
  methods: {
    popUpEnable(newTags, retailerName) {
      eventBus.emit('rfp-mctb-scan-to-buy-redirect', this.popupDirection);
      if (this.popupDirection) {
        if (window.dataLayer !== undefined && newTags !== '' && this.findDatalayer) {
          let tags = {};
          try {
            tags = JSON.parse(newTags);
          } catch (e) {
            console.log('Cannot parse tags', e);
          }

          eventBus.emit('rfpTaggingFoundation', {
            data: tags,
            values: {
              productName: this.productname,
              productId: this.productids,
              retailerName: retailerName,
            },
            extraParams: this.extraParams,
            service: ServiceType.GA,
          });
        }
        this.showPopUp = true;
        this.findDatalayer = true;
        eventBus.emit('rfp-mctb-optional-popup-enable');
        window.eventBus.$emit('rfp-mctb-optional-popup-enable');
      }
    },
    popUpDisable() {
      this.showPopUp = false;
    },
    pageRedirectUrl(redirectURL, OpenInNewWindow, standardTagsString, gsTagsString, retailerName) {
      const service = window.dataLayer ? ServiceType.GA : ServiceType.GSQ;

      try {
        const tags = JSON.parse(window.dataLayer ? standardTagsString : gsTagsString);
        tags &&
          eventBus.emit('rfpTaggingFoundation', {
            data: tags,
            values: {
              productName: this.productname,
              productId: this.productids,
              retailerName: retailerName,
            },
            extraParams: this.extraParams,
            service,
          });
      } catch (e) {
        console.error(
          `error/rfp-mctb-pop-up-mode#pageRedirectUrl: ${service} tag parsing failed`,
          e,
        );
      }

      const target = OpenInNewWindow === true ? '_blank' : '_self';
      window.open(redirectURL, target);
    },
    tabEnable(item, index) {
      this.tabRetailerList = [];
      for (let i = 0; i < this.storeLocatorModeOptions.Product.Retailers.length; i++) {
        if (this.storeLocatorModeOptions.Product.Retailers[i].Country === item.Name) {
          this.tabRetailerList.push(this.storeLocatorModeOptions.Product.Retailers[i]);
        }
      }
      this.tabIndex = index;
      this.tabValue = item;
    },
  },
};
</script>
